export default __webpack_public_path__ + "static/media/ios-screen5.1b3d82be.png";